import script from "./checkbox_v4.vue?vue&type=script&setup=true&lang=js"
export * from "./checkbox_v4.vue?vue&type=script&setup=true&lang=js"

import "./checkbox_v4.vue?vue&type=style&index=0&id=377a6fb4&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377a6fb4"]])

export default __exports__